
import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Send } from 'lucide-react';

const Contact: React.FC = () => {
  return (
    <section id="contact" className="py-24 relative overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-20">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-12"
          >
            <div>
              <span className="text-gold text-xs font-bold tracking-[0.3em] uppercase">Contact</span>
              <h2 className="text-5xl md:text-7xl font-serif font-bold mt-4">
                Prêt pour <br />
                <span className="text-gold-gradient italic">l'Évènement ?</span>
              </h2>
            </div>

            <p className="text-white/60 text-lg font-light leading-relaxed max-w-md">
              Que ce soit pour un mariage d'exception, une soirée privée ou un festival, contactez DJ SAFF pour recevoir un devis personnalisé.
            </p>

            <div className="space-y-8">
              <div className="flex items-center space-x-6 group">
                <a href="mailto:contact@djsaff.com" className="w-14 h-14 glass rounded-2xl flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-dark transition-all">
                  <Mail size={24} />
                </a>
                <div>
                  <p className="text-white/40 text-xs uppercase tracking-widest mb-1">Email</p>
                  <a href="mailto:contact@djsaff.com" className="text-lg font-bold hover:text-gold transition-colors">contact@djsaff.com</a>
                </div>
              </div>

              <div className="flex items-center space-x-6 group">
                <a href="tel:0771744204" className="w-14 h-14 glass rounded-2xl flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-dark transition-all">
                  <Phone size={24} />
                </a>
                <div>
                  <p className="text-white/40 text-xs uppercase tracking-widest mb-1">Téléphone</p>
                  <a href="tel:0771744204" className="text-lg font-bold hover:text-gold transition-colors">07.71.74.42.04</a>
                </div>
              </div>

              <div className="flex items-center space-x-6 group">
                <div className="w-14 h-14 glass rounded-2xl flex items-center justify-center text-gold">
                  <MapPin size={24} />
                </div>
                <div>
                  <p className="text-white/40 text-xs uppercase tracking-widest mb-1">Zone Géographique</p>
                  <p className="text-sm font-bold leading-tight uppercase tracking-wider">Sud Est de la France & France entière</p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="glass rounded-[3rem] p-10 lg:p-16 border-white/5"
          >
            <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-[10px] uppercase tracking-widest text-white/40 ml-4 font-bold">Nom Complet</label>
                  <input 
                    type="text" 
                    placeholder="Votre nom"
                    className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 focus:outline-none focus:border-gold/50 transition-all text-sm"
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-[10px] uppercase tracking-widest text-white/40 ml-4 font-bold">Email</label>
                  <input 
                    type="email" 
                    placeholder="jean@exemple.com"
                    className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 focus:outline-none focus:border-gold/50 transition-all text-sm"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-[10px] uppercase tracking-widest text-white/40 ml-4 font-bold">Type d'Évènement</label>
                <select className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 focus:outline-none focus:border-gold/50 transition-all text-sm text-white/60 appearance-none">
                  <option className="bg-dark">Mariage</option>
                  <option className="bg-dark">Anniversaire</option>
                  <option className="bg-dark">Soirée Entreprise / Cocktail</option>
                  <option className="bg-dark">Club / Festival</option>
                </select>
              </div>

              <div className="space-y-2">
                <label className="text-[10px] uppercase tracking-widest text-white/40 ml-4 font-bold">Votre Message</label>
                <textarea 
                  rows={4}
                  placeholder="Dites-moi en plus sur votre évènement..."
                  className="w-full bg-white/5 border border-white/10 rounded-2xl px-6 py-4 focus:outline-none focus:border-gold/50 transition-all text-sm resize-none"
                ></textarea>
              </div>

              <button className="w-full group relative px-10 py-5 bg-gold text-dark rounded-full font-bold uppercase tracking-widest text-xs overflow-hidden transition-all duration-300 transform hover:scale-[1.02]">
                <span className="relative z-10 flex items-center justify-center">
                  Envoyer la demande <Send className="ml-2 w-4 h-4" />
                </span>
                <div className="absolute inset-0 bg-white translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
